export default "__VITE_ASSET__25a32b54__"